import styled, { css } from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import { Link } from '@sketch/components';
import '../ResponsiveImage/index.js';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage.js';

const Container = styled.div `
  display: grid;
  grid-template: 'thumbnail content';
  grid-template-columns: min-content auto;

  ${breakpoint('base', 'xs') `
    margin-bottom: 8px;
  `};

  ${({ featured }) => featured &&
    css `
      ${breakpoint('base', 'xs') `
        grid-template:
        "thumbnail"
        "content";
      `}
    `};
`;
const Content = styled.div `
  ${({ theme, featured }) => featured
    ? css `
          grid-area: content;
          padding: 22px 24px;
          background-color: ${theme.colors.background.secondary.B};
          border-radius: 0 ${theme.radii.xlarge} ${theme.radii.xlarge} 0;

          :hover {
            ${Description} {
              color: ${theme.colors.foreground.secondary.C};
              text-decoration: underline;
            }
          }

          ${breakpoint('base', 'xs') `
            border-radius: 0 0 ${theme.radii.xlarge} ${theme.radii.xlarge};
          `}
        `
    : `
      display: flex;
      justify-content: center;
      flex-direction: column;
        padding: 0 0 0 16px;
          :hover {
            ${Title} {
              color: ${theme.colors.foreground.secondary.C};
              text-decoration: underline;
            }
          }
      `}
`;
const Thumbnail = styled.div `
  grid-area: thumbnail;
  position: relative;
  width: 64px;
  height: 64px;

  border-radius: ${({ theme }) => theme.radii.xlarge};
  overflow: hidden;

  ${({ theme, featured }) => featured &&
    css `
      width: 172px;
      height: 100%;
      border-radius: ${theme.radii.xlarge} 0 0 ${theme.radii.xlarge};

      ${breakpoint('base', 'xs') `
        width: 100%;

        /* Keep an Aspect Ratio of 16/9 */
        ::before {
          float: left;
          padding-top: 56%;
          content: '';
        }
        ::after {
          display: block;
          content: '';
          clear: both;
        }

        border-radius: ${theme.radii.xlarge} ${theme.radii.xlarge} 0 0;
      `}
    `}
`;
const StyledResponsiveImage = styled(ResponsiveImage) `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const Title = styled.h1 `
  margin: 0;
  font-size: ${({ theme, featured }) => featured ? theme.fontSizes.E : theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme, featured }) => featured
    ? theme.colors.foreground.secondary.D
    : theme.colors.foreground.secondary.A};

  ${({ featured }) => featured && `text-transform: uppercase;`}
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const Description = styled.p `
  margin: 4px 0 0 0;
  font-size: ${({ theme, featured }) => featured ? theme.fontSizes.F : theme.fontSizes.E};
  font-weight: ${({ theme }) => theme.fontWeights.medium};

  color: ${({ theme, featured }) => featured
    ? theme.colors.foreground.secondary.A
    : theme.colors.foreground.secondary.D};
`;
const StyledLink = styled(Link) `
  width: 100%;
  white-space: break-spaces;
`;

export { Container, Content, Description, StyledLink, StyledResponsiveImage, Thumbnail, Title };
